import { createSelector } from '@reduxjs/toolkit';
import { selectHouseFullAddress } from '../houseInfo';
import { selectUser } from '../user';

export const selectMyHouseBannerLink = createSelector(selectHouseFullAddress, selectUser, (address, user) => {
  if (user.isAuthenticated && user.isAgent) {
    return null;
  }

  return `https://www.cian.ru/my-home/?address=${address}&from=house_card&isFormOpen=1`;
});
